import React from 'react';
import Header from './common/Header.jsx';
import Footer from './common/Footer.jsx';
import NotificationContainer from './common/NotificationContainer.jsx';
import {connect} from 'react-redux';
import {getProfile} from './profile/redux/actions';
import UserSession from './auth/UserSession';
import _ from 'lodash';
import Helmet from 'react-helmet';
import ImageUtils from './utils/ImageUtils';
import PageUtils from './utils/PageUtils';

const headerlessLocations = ['confirm-email'];
const footerlessLocations = ['confirm-email'];

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      showHeader: true,
      showFooter: true
    };
  }

  componentWillMount() {
    if (UserSession.getToken() && !this.props.profile) {
      this.props.dispatch(getProfile());
    }
  }

  componentDidMount() {
    this.setHeaderFooterState(this.props.location);
  }

  componentWillReceiveProps(nextProps) {
    const hasLocationChanged = _.get(nextProps, 'location.pathname') !== _.get(this.props, 'location.pathname');
    if (hasLocationChanged) {
      this.setHeaderFooterState(nextProps.location);
    }
  }

  setHeaderFooterState(location) {
    let showHeader = headerlessLocations.indexOf(location.pathname.split('/')[1]) < 0,
      showFooter = footerlessLocations.indexOf(location.pathname.split('/')[1]) < 0;

    if (showHeader !== this.state.showHeader || showFooter !== this.state.showFooter) {
      this.setState({showHeader, showFooter});
    }
  }

  render() {
    const {auth, profile} = this.props;
    const {showHeader, showFooter} = this.state;

    return (
      <div className="ba-site">
        <Helmet defaultTitle={PageUtils.getTitle()}
                titleTemplate={`${PageUtils.getTitle()} - %s`}
                meta={[
                  {name: 'twitter:card', content: 'summary'},
                  {property: 'og:title', content: PageUtils.getTitle()},
                  {property: 'og:site_name', content: PageUtils.getTitle()},
                  {property: 'og:image', content: ImageUtils.getAppLogoUrl()},
                  {property: 'og:description', content: 'Super cool Base App from TSL'}
                ]}/>
        {showHeader ?
          <Header auth={auth}
                  profile={profile}
                  onHomeClick={() => {
                  }}/>
          : null}
        <div className="ba-main">
          {this.props.children}
        </div>
        {showFooter ?
          <Footer/>
          : null}
        <NotificationContainer/>
      </div>
    );
  }
}

App.displayName = 'App';

function mapStateToProps(state) {
  return {
    auth: state.auth,
    profile: _.get(state.profile, 'profile', null)
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./shared/App.jsx